import { IMultiLanguage } from '@/shared/model/multi-language.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IAddon } from '@/shared/model/addon.model';
import { IMenuVariant } from '@/shared/model/menu-variant.model';

export interface IAddonCategory {
  id?: number;
  ordinal?: number | null;
  enabled?: boolean | null;
  nonfood?: boolean | null;
  multiple?: boolean | null;
  title?: IMultiLanguage | null;
  titleValue?: string | null;
  discount?: IDiscount | null;
  addons?: IAddon[] | null;
  menuVariant?: IMenuVariant | null;
}

export class AddonCategory implements IAddonCategory {
  constructor(
    public id?: number,
    public ordinal?: number | null,
    public enabled?: boolean | null,
    public nonfood?: boolean | null,
    public multiple?: boolean | null,
    public title?: IMultiLanguage | null,
    public titleValue?: string | null,
    public discount?: IDiscount | null,
    public addons?: IAddon[] | null,
    public menuVariant?: IMenuVariant | null
  ) {
    this.enabled = this.enabled ?? true;
    this.nonfood = this.nonfood ?? false;
    this.multiple = this.multiple ?? false;
    this.addons = this.addons ?? [];
  }
}
